"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataSourceType;
(function (DataSourceType) {
    DataSourceType[DataSourceType["Remote"] = 0] = "Remote";
    DataSourceType[DataSourceType["Local"] = 1] = "Local";
})(DataSourceType = exports.DataSourceType || (exports.DataSourceType = {}));
class DataSourceProvider {
    constructor(name, sourceType) {
        this.name = name;
        this.sourceType = sourceType;
        this.data = [];
    }
    getData() {
        return this.data;
    }
    addData(data) {
        this.data.push(data);
    }
    clearData() {
        this.data = [];
    }
    getDataByKey(key) {
        return this.data.find((data) => data.key === key).value;
    }
}
exports.DataSourceProvider = DataSourceProvider;
//# sourceMappingURL=data.source.provider.js.map